import { Card, CardBody } from '../components/ui/Card'
import { ButtonLink } from '../components/ui/Button'

interface PlaceholderProps {
  title: string
  /** What this page will do, so the route is self-documenting rather than a blank panel. */
  planned: string
}

/**
 * Stands in for a route that is designed but not built yet. Preferred over omitting the
 * route: navigation stays honest, and nothing dead-ends in a 404.
 */
export function Placeholder({ title, planned }: PlaceholderProps) {
  return (
    <div className="mx-auto w-full max-w-2xl px-4 py-16 sm:px-6">
      <Card>
        <CardBody className="p-8">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          <p className="mt-3 text-[color:var(--text-muted)]">{planned}</p>
          <p className="mt-6 text-sm text-[color:var(--text-muted)]">
            Not built yet. See <code className="font-mono text-xs">docs/roadmap.md</code> for where
            this sits in the plan.
          </p>
          <div className="mt-7">
            <ButtonLink to="/" variant="secondary">
              Back to home
            </ButtonLink>
          </div>
        </CardBody>
      </Card>
    </div>
  )
}

export function NotFound() {
  return (
    <Placeholder
      title="Page not found"
      planned="That link does not match anything on the site. It may have been mistyped, or the page may have moved."
    />
  )
}
